import axiosInstance from '../axios/axiosInstance';

export const ACTIVITY_STATUSES = ['overdue', 'recent', 'never_visited', 'visited'];
export const ACTIVITY_PAGE_SIZE = 20;

export function firstApiError(error) {
    const data = error?.response?.data;
    const errors = data?.errors;
    if (errors && typeof errors === 'object') {
        const first = Object.values(errors).flat().find(Boolean);
        if (first) return String(first);
    }
    return data?.message || null;
}

export async function fetchPatientActivity({
    status = 'overdue',
    search = '',
    page = 1,
    perPage = ACTIVITY_PAGE_SIZE,
} = {}) {
    const params = { status, page, per_page: perPage };
    if (search) params.search = search;
    const response = await axiosInstance.get('/patients/activity', { params });
    const body = response.data ?? {};
    const items = Array.isArray(body.data) ? body.data : [];
    const meta = body.meta ?? {};
    return {
        items,
        status: body.status ?? status,
        referenceDate: body.reference_date ?? null,
        cutoffDate: body.cutoff_date ?? null,
        count: Number(body.count ?? meta.total ?? items.length) || 0,
        meta,
        links: body.links ?? null,
        pagination: {
            current: Number(meta.current_page ?? page) || 1,
            pageSize: Number(meta.per_page ?? perPage) || perPage,
            total: Number(meta.total ?? body.count ?? items.length) || 0,
        },
    };
}

export async function fetchPatientActivitySummary(search = '') {
    const params = {};
    if (search) params.search = search;
    const response = await axiosInstance.get('/patients/activity/summary', { params });
    const body = response.data ?? {};
    const data = body.data ?? {};
    return {
        total: Number(data.total) || 0,
        overdue: Number(data.overdue) || 0,
        recent: Number(data.recent) || 0,
        never_visited: Number(data.never_visited) || 0,
        visited: Number(data.visited) || 0,
        referenceDate: body.reference_date ?? null,
        cutoffDate: body.cutoff_date ?? null,
    };
}
